/**
 * Hash FNV-1a de 32 bits (determinístico, barato). Mismo string → mismo número en todos los
 * clientes: útil para derivar valores estables por-entidad sin sincronizar nada (mismo patrón que
 * `FootstepSystem.footstepVariantIndex`).
 */
export function fnv1a(str: string): number {
  let h = 0x811c9dc5; // offset basis
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h;
}

/**
 * Offset determinístico (0..cicloMenos1 vía `% ciclo` en el caller) para la fase del ciclo de
 * respiración de una entidad. Mismo id → mismo offset en TODOS los clientes → todos ven la misma
 * animación para la misma entidad; ids distintos quedan escalonados (no respiran a la vez).
 * Combinado con `Date.now()` como base de tiempo compartida, la fase queda sincronizada.
 */
export function breathingPhaseOffset(id: string): number {
  return fnv1a(id);
}
